import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
const createUpdatePluginSettings = (rawClient) => {
    const endpoint = allpeepPayloadEndpoint(rawClient, '/profiles/current/pluginSettings/:namespace/:name', 'patch');
    const update = (patch, options) => endpoint(JSON.stringify(patch), Object.assign(Object.assign({}, options), { headers: Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, options === null || options === void 0 ? void 0 : options.headers) }));
    update.queryKey = endpoint.queryKey;
    return update;
};
export const profiles = (rawClient, eventSource) => ({
    current: {
        read: allpeepNoPayloadEndpoint(rawClient, '/profiles/current'),
        update: allpeepPayloadEndpoint(rawClient, '/profiles/current', 'patch'),
        notifications: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications'),
        notificationStats: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/stats'),
        notificationTypes: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/types'),
        reposts: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/reposts'),
        bookmarkedIds: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/bookmarkedIds'),
        markAllNotificationsAsSeen: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/mark-all-seen', 'put'),
        readSettings: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/settings'),
        updateSettings: allpeepPayloadEndpoint(rawClient, '/profiles/current/settings', 'put'),
        readPluginSettings: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/pluginSettings/:namespace/:name'),
        updatePluginSettings: createUpdatePluginSettings(rawClient),
        accessTokens: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/access-tokens'),
        createAccessToken: allpeepPayloadEndpoint(rawClient, '/profiles/current/access-tokens', 'post'),
        revokeAccessToken: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/access-tokens/:accessTokenId', 'delete'),
        sessionEvents: {
            listen: eventSource('/profiles/current/session/events'),
        },
    },
    list: allpeepNoPayloadEndpoint(rawClient, '/profiles'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id'),
    findByHandle: allpeepNoPayloadEndpoint(rawClient, '/profiles/by-handle/:handle'),
    follow: allpeepPayloadEndpoint(rawClient, '/profiles/:id/follow', 'post'),
    unfollow: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/follow', 'delete'),
    followers: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/followers'),
    following: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/following'),
    commonGroups: allpeepNoPayloadEndpoint(rawClient, '/profiles/:profileId/common-groups'),
});
